var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5C7.05228 5 7.5 4.55228 7.5 4C7.5 3.44772 7.05228 3 6.5 3C5.94772 3 5.5 3.44772 5.5 4C5.5 4.55228 5.94772 5 6.5 5ZM10.5 5C11.0523 5 11.5 4.55228 11.5 4C11.5 3.44772 11.0523 3 10.5 3C9.94772 3 9.5 3.44772 9.5 4C9.5 4.55228 9.94772 5 10.5 5ZM7.5 8C7.5 8.55228 7.05228 9 6.5 9C5.94772 9 5.5 8.55228 5.5 8C5.5 7.44772 5.94772 7 6.5 7C7.05228 7 7.5 7.44772 7.5 8ZM10.5 9C11.0523 9 11.5 8.55228 11.5 8C11.5 7.44772 11.0523 7 10.5 7C9.94772 7 9.5 7.44772 9.5 8C9.5 8.55228 9.94772 9 10.5 9ZM7.5 12C7.5 12.5523 7.05228 13 6.5 13C5.94772 13 5.5 12.5523 5.5 12C5.5 11.4477 5.94772 11 6.5 11C7.05228 11 7.5 11.4477 7.5 12ZM10.5 13C11.0523 13 11.5 12.5523 11.5 12C11.5 11.4477 11.0523 11 10.5 11C9.94772 11 9.5 11.4477 9.5 12C9.5 12.5523 9.94772 13 10.5 13Z",
    fill: "white",
    fillOpacity: 0.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMove);
export default __webpack_public_path__ + "static/media/icon-move.fb178213b1ad0c8e82bd6f0b6730159b.svg";
export { ForwardRef as ReactComponent };